import React from "react";
import Slider from "react-slick";
import Heading from "../Products/Heading";
import Product from "../Products/Product";

// ✅ ONLY your available images
import darkChocolate from "../../../assets/darkchoco.png";
import milkChocolate from "../../../assets/milkchoco.png";
import truffleBox from "../../../assets/trufflebox.png";
import roastedItems from "../../../assets/roasteditems.png";
import giftBox from "../../../assets/giftbox.png";

import SampleNextArrow from "./SampleNextArrow";
import SamplePrevArrow from "./SamplePrevArrow";

const ChocolateSection = () => {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1025,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 769,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <div className="w-full pb-16">
      <Heading heading="Chocolates & Roasteries" />
      <Slider {...settings}>

        {/* 1: Gift Box */}
        <div className="px-2">
          <Product
            _id="C1005"
            img={giftBox}
            productName="Gift Chocolate Box"
            color="Mixed"
            badge={true}
            des="Perfect for gifting."
          />
        </div>

        {/* 2: Milk Chocolate */}
        <div className="px-2">
          <Product
            _id="C1002"
            img={milkChocolate}
            productName="Milk Chocolate"
            color="Light Brown"
            badge={false}
            des="Smooth and sweet milk chocolate."
          />
        </div>

        {/* 3: Chocolate Truffles */}
        <div className="px-2">
          <Product
            _id="C1003"
            img={truffleBox}
            productName="Chocolate Truffles"
            color="Mixed"
            badge={true}
            des="Luxury assorted truffles."
          />
        </div>

        {/* 4: Roasted Cocoa */}
        <div className="px-2">
          <Product
            _id="C1004"
            img={roastedItems}
            productName="Roasted NUTS"
            color="Brown"
            badge={false}
            des="Fresh roasted cocoa items."
          />
        </div>

        {/* 5: Dark Chocolate (moved to last) */}
        <div className="px-2">
          <Product
            _id="C1001"
            img={darkChocolate}
            productName="Dark Chocolate"
            color="Dark Brown"
            badge={true}
            des="High cocoa content dark chocolate."
          />
        </div>

      </Slider>
    </div>
  );
};

export default ChocolateSection;